import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CheckIcon from '@mui/icons-material/Check';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { IconButton, Box, Grid, Avatar } from '@mui/material';
import { formatDistanceToNow } from 'date-fns';
import React from 'react';
import { FirebaseNotification } from 'wisestep-api';
import { WsColors, WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

interface NotificationCardProps {
  notification: FirebaseNotification & {
    avatar?: string;
    sender?: string;
  };
  onMarkAsRead: (id: string) => void;
}

export const NotificationCard: React.FC<NotificationCardProps> = ({
  notification,
  onMarkAsRead,
}) => {
  const handleMarkAsRead = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (notification.id) {
      onMarkAsRead(notification.id);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: notification.isRead ? WsColors.TertiaryShades50 : WsColors.White,
        '&:hover': { backgroundColor: WsColors.TertiaryShades100 },
        p: 2,
      }}
    >
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item>
          {notification.type === 'Reminder' ? (
            <Box
              sx={{
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                backgroundColor: WsColors.TertiaryShades50,
              }}
            >
              <NotificationsIcon sx={{ fontSize: 24, color: WsColors.TheBlues500 }} />
            </Box>
          ) : (
            <Avatar
              src={notification.avatar}
              alt={notification.sender || 'User'}
              sx={{ width: 40, height: 40 }}
            >
              <AccountCircleIcon sx={{ fontSize: 24 }} />
            </Avatar>
          )}
        </Grid>

        <Grid item xs>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} bold color={WsTypoColors.TERTIARY900}>
            {notification.type === 'CANDIDATE_SUBMISSION' ? 'Submission' : 'Notifictaion'}
          </WsTypography>

          <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.PRIMARY}>
            {notification.message ?? 'Notification regarding candidate'}
          </WsTypography>
        </Grid>

        <Grid item sx={{ minWidth: 100, textAlign: 'right' }}>
          <WsTypography variant={WsTypoVariants.CAPTION} color={WsTypoColors.SECONDARY}>
            {notification.createdOn &&
              formatDistanceToNow(new Date(notification.createdOn), { addSuffix: true })}
          </WsTypography>
          {!notification.isRead && (
            <IconButton
              onClick={handleMarkAsRead}
              size="small"
              sx={{
                mt: 1,
                color: WsColors.TheBlues500,
                backgroundColor: WsColors.TertiaryShades50,
                '&:hover': {
                  backgroundColor: WsColors.TertiaryShades100,
                },
              }}
            >
              <CheckIcon sx={{ fontSize: 16 }} />
            </IconButton>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
